export default {"src":"/_next/static/media/choix.671772f7.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};